<div [ngClass]="layoutService.isTabletDownView.value ? 'action-item-sp' : 'action-item'" [class.is-last]="isLast">
  <div class="user-avatar">
    <img src="{{ action.last_create_user.avatar }}" data-cy="user-avatar" />
  </div>

  <div class="action-info">
    <div class="text-info" [class.label-text]="action.is_involved" data-cy="text-action">
      <p [innerHTML]="sanitized.bypassSecurityTrustHtml(actionTextInfo)"></p>
    </div>

    <div class="subject-info">
      <img class="subject-icon" data-cy="subject-icon" src="{{ actionIcon }}" />
      <a
        class="subject-name truncate-text"
        data-cy="subject-name"
        [ngClass]="canViewSubject ? 'spen-util-link' : 'disable-link'"
        (click)="onSubjectClick($event)"
      >
        <span>{{ actionSubjectName }}</span>
      </a>
    </div>

    <div class="spaces-time-info">
      <p class="time muted-text" data-cy="last-created-at">{{ action.last_created_at }}</p>
      @if (layoutService.isTabletDownView.value) {
        <div class="spaces truncate-text">
          @for (space of action.spaces; track space) {
            <span class="space-name" data-cy="spaces-name">{{ space.name }}</span>
          }
        </div>
      } @else {
        <div class="spaces">
          @for (space of action.spaces; track space) {
            <a class="space-name spen-util-link" data-cy="spaces-name" (click)="onSpaceClick(space.id)">{{ space.name }}</a>
          }
        </div>
      }
    </div>
  </div>
</div>
